/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/

head.ready("appJS", function() {
  $(document).ready(function() {

    $('input,select,textarea,select').each(function(){
      //set active class to this element's label
      $(this).on('focus',function(){
        //if ( $(this).is('[readonly]') ) {
      		
      	//}else{
      		$(this).prev().addClass('active');
      	//}
      });
      $(this).on('blur',function(){
        $(this).prev().removeClass('active');
      });
      //set required class to this element's label if element is required
      if($(this).prop('required')){
        $(this).prev().addClass('required');
      }

      $(this).closest('ac-formgroup').find('label:first-child').each(function(){
          if(this.scrollWidth > $(this).innerWidth()){
            //label has overflowing text! Add tooltip
            
          }else{
            
          }
          
        });

    });


    
    angelCake.layoutForm = function(fieldset){
      //alert('ranx');
      //if (!fieldset.closest('form[data-smartdesk-filters]')) {

        fieldset.each(function(){
          var newClass = '';
          var widthCounter = 0;
          var prevWidth = 0;
          $(this).children('ac-formgroup').each(function(){
            $(this).css({'max-width':''});

            widthCounter += $(this).outerWidth();
            var leftSiblingWidth = $(this).prev().outerWidth();
            var parentWidth = $(this).parent().innerWidth();
            var newWidth = ( parentWidth - prevWidth ) + leftSiblingWidth;
            var myWidth = $(this).outerWidth();
            if(widthCounter>=parentWidth){
                if($(this).prev().attr('data-dont-resize') == ''){
                  //don't do anything
                }else{
                  $(this).prev().css({'max-width':newWidth});
                }
                widthCounter=myWidth;
                prevWidth = myWidth;                  
            }
            prevWidth = widthCounter;
            
          });
        });
      //}
    };
    var resizeTimer;
    $(window).on('resize',function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        angelCake.layoutForm($('ac-fieldset'));
      }, 100);
      
    });
    angelCake.layoutForm($('ac-fieldset'));
  });
});